import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Link } from 'react-router-dom';
export function ManagePackages() {
  const packages = [{
    id: 1,
    position: 1,
    name: 'Starter Bundle',
    type: 'Preset package',
    price: '$99.00',
    publish: true
  }, {
    id: 2,
    position: 2,
    name: 'Pro Bundle',
    type: 'Generic Package',
    price: '$199.00',
    publish: true
  }, {
    id: 3,
    position: 3,
    name: 'Enterprise Pack',
    type: 'Preset package',
    price: '$499.00',
    publish: false
  }];
  return <div className="space-y-6" data-id="element-488">
      <div className="flex items-center justify-between" data-id="element-489">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-490">Manage Packages</h1>
        <Link to="/packages/add" data-id="element-491">
          <Button className="gap-2" data-id="element-492">
            <Plus className="h-4 w-4" data-id="element-493" />
            Add
          </Button>
        </Link>
      </div>

      <Card className="overflow-hidden" data-id="element-494">
        <div className="overflow-x-auto" data-id="element-495">
          <table className="w-full text-sm text-left" data-id="element-496">
            <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-497">
              <tr data-id="element-498">
                <th className="px-4 py-3" data-id="element-499">Position</th>
                <th className="px-4 py-3" data-id="element-500">Name</th>
                <th className="px-4 py-3" data-id="element-501">Package Types</th>
                <th className="px-4 py-3" data-id="element-502">Price</th>
                <th className="px-4 py-3" data-id="element-503">Publish</th>
                <th className="px-4 py-3" data-id="element-504">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-505">
              {packages.map(pkg => <tr key={pkg.id} className="hover:bg-slate-50" data-id="element-506">
                  <td className="px-4 py-3" data-id="element-507">{pkg.position}</td>
                  <td className="px-4 py-3 font-medium" data-id="element-508">{pkg.name}</td>
                  <td className="px-4 py-3 text-slate-600" data-id="element-509">{pkg.type}</td>
                  <td className="px-4 py-3" data-id="element-510">{pkg.price}</td>
                  <td className="px-4 py-3" data-id="element-511">
                    <Badge variant={pkg.publish ? 'success' : 'secondary'} data-id="element-512">
                      {pkg.publish ? 'Yes' : 'No'}
                    </Badge>
                  </td>
                  <td className="px-4 py-3" data-id="element-513">
                    <div className="flex items-center gap-2" data-id="element-514">
                      <Button variant="ghost" size="icon" title="View" data-id="element-515">
                        <Eye className="h-4 w-4 text-slate-500" data-id="element-516" />
                      </Button>
                      <Link to={`/packages/edit/${pkg.id}`} data-id="element-517">
                        <Button variant="ghost" size="icon" title="Edit" data-id="element-518">
                          <Edit className="h-4 w-4 text-blue-600" data-id="element-519" />
                        </Button>
                      </Link>
                      <Button variant="ghost" size="icon" title="Delete" data-id="element-520">
                        <Trash2 className="h-4 w-4 text-red-600" data-id="element-521" />
                      </Button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}